<template>
    <div v-if="params.data" class="flex gap-2">
        <template v-if="invoiceUuid && subAccountUuid">
            <inv-link-resolver :uuid="invoiceUuid" :sub-account-uuid="subAccountUuid" :invoice-no="transactionLine.invoiceNo" />
        </template>
    </div>
</template>

<script setup lang="ts">

import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide} from 'vue'
import InvLinkResolver from '@/textTokenizer/InvLinkResolver.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transactionLine = computed(() => {
    return props.params.data
})

const invoiceUuid = computed(() => {
    return transactionLine.value.invoiceUuid
})

const subAccountUuid = computed(() => {
    return transactionLine.value.subAccountUuid
})

</script>

<style scoped>

</style>